var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2213 6.65297C21.1988 6.06915 21.1988 5.50778 21.1988 4.96887C21.1988 4.54223 20.862 4.20541 20.4353 4.20541C17.1345 4.18296 14.6196 3.23986 12.5313 1.21893C12.2394 0.927022 11.7454 0.927022 11.4535 1.21893C9.36517 3.23986 6.85024 4.18296 3.57186 4.18296C3.14522 4.18296 2.8084 4.51978 2.8084 4.94642C2.8084 5.48533 2.8084 6.0467 2.78594 6.65297C2.67367 12.1993 2.51649 19.7665 11.7454 22.9551C11.8352 22.9775 11.9026 23 11.9924 23C12.0822 23 12.172 22.9775 12.2394 22.9551C21.4683 19.7665 21.3111 12.1993 21.2213 6.65297Z",
    fill: "url(#paint0_radial_37492_20700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_37492_20700",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0005 8) rotate(-172.504) scale(38.3275 32.197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364383,
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364483,
    stopColor: "#D2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#D2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536558,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.a92bc92cb02191ac73bcc538dcea696f.svg";
export { ForwardRef as ReactComponent };